import React from 'react';
import { useCommonClient } from '@/app/common/commonClientProvider.tsx';
import { useOverlayContext } from '@/app/common/context/OverlayContext.ts';
import { StickyFooterContainer } from './styled.ts';

type ModalStickyFooterProps = {
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

// Sticky footer wrapper for modals that opt into scroll shadows (OpenXModal `scrollShadows`).
// When the modal's scroll body overflows under the footer, OverlayContext flips `footerShadow`
// and this renders the top shadow + border (matching BasicModalFooterV2 / the EvoFilterModal footer).
// Use this for bespoke footer content (e.g. price + CTA bars) — BasicModalFooterV2 covers the
// apply/clear case. In the legacy (non-Evo) flow `scrollShadows` is off, so this is a passthrough
// and the design-system footer keeps its own padding/shadow.
const ModalStickyFooter = ({ children, ...rest }: ModalStickyFooterProps): React.ReactNode => {
  const { isEvoLayout } = useCommonClient();
  const { footerShadow } = useOverlayContext();

  if (!isEvoLayout) {
    return children;
  }

  return (
    <StickyFooterContainer $showShadow={footerShadow} data-swipe-dismiss-ignore={true} {...rest}>
      {children}
    </StickyFooterContainer>
  );
};

export default ModalStickyFooter;
